<table [dataSource]="items" mat-table class="condensed">
  <ng-container matColumnDef="id">
    <th *matHeaderCellDef mat-header-cell>Konto</th>
    <td *matCellDef="let row;" mat-cell style="padding: 0 4px 0 0">
      {{ row.id }}
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell>Namn</th>
    <td *matCellDef="let row;" mat-cell style="padding: 0 4px 0 0">
      {{ row.name }}
    </td>
  </ng-container>
  <ng-container matColumnDef="listInterest">
    <th *matHeaderCellDef mat-header-cell>Listränta</th>
    <td *matCellDef="let row;" mat-cell style="padding: 0 4px 0 0">
      {{ row.listInterest() | number : '1.0-2': 'sv' }} %
    </td>
  </ng-container>
  <tr *matHeaderRowDef="columns()" mat-header-row style="font-weight: bold"></tr>
  <tr *matRowDef="let row; columns: columns()" mat-row></tr>
</table>